import React from "react";
import { Link } from "react-router-dom";

export const UserLinkColumnFormatter = (dataField, cell, row) => { //12th June 2020, 10:00 AM
console.log("dataField",cell)
let temp = ''
if(cell?.user?.user_id){
    temp = cell?.user?.user_id.split('').slice(2, 4)
} else {
    temp = cell?.user.split('').slice(2, 4)
}
let code = temp[0] + temp[1]
if(code=='DE'){
    code='D11'
}
//console.log(code,"company code temp",temp)
 return (cell && cell?.user&& cell?.user?.user_id) ? 
 <Link to={`/user-profile/${cell?.user?.user_id}/${code}`} style={{ color: '#007bff', fontWeight: 600}} target="_blank">{cell?.user?.user_id}&nbsp;<i class="flaticon-eye icon-nm"></i></Link>  
 : <Link to={`/user-profile/${cell?.user}/${code}`} style={{ color: '#007bff', fontWeight: 600}} target="_blank">{cell?.user}&nbsp;<i class="flaticon-eye icon-nm"></i></Link>

};